import { useCopyToClipboard } from '@passkeys/hooks';
import Address from '@passkeys/ui/address';
import FramedIcon from '@passkeys/ui/framed-icon';

import { cn } from '@/ui/utils/classnames';

export interface CopyableAddressProps {
  value: string;
  className?: string;
  dataTestId?: string;
}

function CopyableAddress({
  value,
  className,
  dataTestId,
}: CopyableAddressProps) {
  const { copy, copied } = useCopyToClipboard();

  return (
    <div className={cn('col-start-2 flex items-center gap-2', className)}>
      <Address condensed address={value} />
      <button
        className={cn(copied && 'pointer-events-none')}
        onClick={() => copy(value)}
        type="button"
        data-testid={dataTestId}
      >
        <FramedIcon
          forceLight
          name={copied ? 'copy-filled-check' : 'copy'}
          shape="squared"
          className="transition-opacity duration-[300ms] hover:opacity-60 theme-dark:text-black"
        />
      </button>
    </div>
  );
}

export default CopyableAddress;
